import { Factory } from '../Factory';

namespace app.services.metrics {

  export abstract class BaseProcessingMetricsService implements IService {
    protected resourceWrapperService: ResourceWrapperService;
    protected projectMetricsByExtension: ProcessingMetrics;
    protected projectMetricsByType: ProcessingMetrics;
    protected collectionMetricsByExtension: ProcessingMetrics;
    protected collectionMetricsByType: ProcessingMetrics;
    private configService: app.services.IConfigService;

    protected constructor($resource: angular.resource.IResourceService, configService: app.services.IConfigService, resourceWrapperService: ResourceWrapperService) {
      this.configService = configService;
      this.resourceWrapperService = resourceWrapperService;
    }

    public async GetExtensionByCount(projectId: string, collectionId?: string) {
      if (collectionId) {
        return this.collectionMetricsByExtension.count.query({
          id: projectId,
          collectionId: collectionId
        });
      }

      return this.projectMetricsByExtension.count.query({id: projectId});
    }

    public async GetExtensionBySize(projectId: string, collectionId?: string) {
      if (collectionId) {
        return this.collectionMetricsByExtension.size.query({
          id: projectId,
          collectionId: collectionId
        });
      }

      return this.projectMetricsByExtension.size.query({id: projectId});
    }

    public async GetTypeByCount(projectId: string, collectionId?: string) {
      if (collectionId) {
        return this.collectionMetricsByType.count.query({id: projectId, collectionId: collectionId});
      }

      return this.projectMetricsByType.count.query({id: projectId});
    }

    public async GetTypeBySize(projectId: string, collectionId?: string) {
      if (collectionId) {
        return this.collectionMetricsByType.size.query({id: projectId, collectionId: collectionId});
      }

      return this.projectMetricsByType.size.query({id: projectId});
    }
  }
}

// ES6 export for modules that import BaseProcessingMetricsService
export const BaseProcessingMetricsService = app.services.metrics.BaseProcessingMetricsService;
